export default __webpack_public_path__ + "static/media/reception.05727018.png";